import type { WidgetBootstrapResponse } from '../types/PublicBookingChannelTypes'
import type { DeepLinkServiceKey } from './deeplink'
import { primaryService, type JobIconName, type JobType } from './jobTypes'

/** Which of the channel's categories each booking-link key means. */
const CATEGORY_FOR_KEY: Record<DeepLinkServiceKey, JobIconName> = {
  mot: 'mot',
  service: 'servicing',
  tyres: 'tyres',
  repair: 'repairs',
  diagnostics: 'diagnostics',
}

export interface DeepLinkServiceChoice {
  jobType: JobType
  /**
   * The service to put in the basket. Null when the category holds a real
   * choice and the garage has not nominated a primary service: the customer
   * still has to decide, so the link opens the category instead of deciding
   * for them.
   */
  service: WidgetBootstrapResponse.ServiceItem | null
}

/**
 * What a booking link's service key selects on this channel.
 *
 * Categories are the garage's own, so the key is matched the same way the
 * category tiles get their icons. Null when the garage offers nothing of that
 * kind, in which case the link just opens the widget.
 */
export function resolveDeepLinkService(
  jobTypes: JobType[],
  key: DeepLinkServiceKey | null
): DeepLinkServiceChoice | null {
  if (!key) return null

  const jobType = jobTypes.find((candidate) => candidate.icon === CATEGORY_FOR_KEY[key])
  if (!jobType) return null

  return { jobType, service: primaryService(jobType) }
}
